import Vue from 'vue'
import Vuex from 'vuex'
import agrocostos from './modules/agrocostos'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    agrocostos
  }
})
